import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";

import Modalmessage from "../../AdminDashboard/MentorMessages/Modal/Messagemodal";

import "./style.scss";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import buttonSendMessage from "../../../../../assets/images/Icon_Chat_Message.svg";
import Pagination from "react-js-pagination";
import { Button as MaterialButton } from "@material-ui/core";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import mentorIcon from "../../../../../assets/svg/dashboard/Mentor-iconCircle.svg";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { Country, State, City } from "country-state-city";
import profile from "../../../../../assets/svg/cohortMeetingCircle.svg";
import excelButton from "../../../../../assets/images/maargThemeXls2.png";
import {
  getCohortMentorList,
  getMentorCohortApplicationList,
} from "../../MentorDashboard/dependencies/action";
import CohortSummaryModal from "../../../../common/cohortSummaryModal";
import MentorshipSummaryModal from "../../../../common/mentorshipSummaryModal";
import api from "../../../../common/dependencies/utils/Api";

import axios from "axios";
import {
  COHORT_NAME_LIST,
  COHORT_ADMIN_COUNTER,
  SEND_MESSAGE,
  GET_NAMES_DATA,
  ALL_CONVERSATION,
  MESSAGES,
  MY_MENTORSHIP_LIST,
  MATCH_MENTOR_LIST,
  MATCH_STARTUP_LIST,
  DOWNLOAD_EXCEL_TOTAL_COHORT_MENTORSHIP_HOURS,
} from "../../../../common/constants/ApplicationUrl";

// import {
//   getStartupApplication,
//   getCountersStartUpList,
// } from "../dependencies/action";
import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as moment from "moment";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import Select from "react-select";
import Button from "../../AdminDashboard/Button";
import mentorshipIcon2 from "../../../../../assets/svg/dashboard/view-Mentroships.svg";
import mentorshipIcon from "../../../../../assets/svg/cohortMeeting.svg";
import mentorshipIcon3 from "../../../../../assets/svg/startupMiniCircle.svg";
import mentorshipIcon4 from "../../../../../assets/svg/mentorsMiniCircle.svg";
import { getNamesList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import {
  postMentorModuleCohort,
  postMentorModuleStartupCohort,
  getmatchTableList,
  cohortProgramSpotLight,
  cohortListTable,
} from "../../MentorDashboard/dependencies/action";
const CohortProgram = (props) => {
  const html = document.getElementsByTagName("html")[0];
  const {
    getNamesList,
    getNamesListData,
    getMentorCohortApplicationList,
    postMentorModuleCohort,
    cohortStartupData,
    cohortMentorData,
    postMentorModuleStartupCohort,
    getmatchTableList,
    cohortMatchMakingList,
    getStepperTooltipData,
    getStepperData,
    cohortProgramSpotLight,
    cohortSpotLightData,
  } = props;
  // const imageUrl = "https://uat-nmp-api.startupindia.gov.in/v1/document/;";
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [activeText, setActiveText] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");
  const LoginRole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  const [mentorShipReqData, setMentorShipReqData] = useState();
  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const history = useHistory();
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");
  const [filterCohortname, setFilterCohortname] = useState("");
  const [newCohortId, setnewCohortId] = useState("");
  const [cohortNewData, setCohortNewData] = useState("");
  const [filterCohortId, setFilterCohortId] = useState("");
  const [cohortnameList, setcohortnameList] = useState([]);
  const [cohortnameId, setcohortnameId] = useState([]);
  const [cohortfilterGo, setcohortfilterGo] = useState(false);
  const [cohortAdminCounter, setCohortAdminCounter] = useState({});
  const LoginUser = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };

  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("VERIFIED");
  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [allMentorNames, setAllMentorNames] = useState();
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [modalVisibility, setModalVisibility] = useState(false);
  const [modalVisibility2, setModalVisibility2] = useState(false);
  const [fromModule, setFromModule] = useState("");
  const [modalData, setModalData] = useState("");
  const [cohortModalData, setCohortModalData] = useState("");
  const [cohortModalMentorData, setCohortModalMentorData] = useState();
  const [cohortModalMentorData2, setCohortModalMentorData2] = useState();
  const [cohortModalStartupData, setCohortModalStartupData] = useState([]);
  const [allCohortMentors, setAllCohortMentors] = useState();
  const [groupMessages, setGroupmessages] = useState();
  const [allCohortStartups, setAllCohortStartups] = useState();
  const [file, setFile] = useState(null);
  const [allMentorList, setAllMentorList] = useState();
  const [allStartupList, setAllStartupList] = useState();
  const [taggingList, setTaggingList] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [newMenuStartup, setNewMenuStartup] = useState();
  const [chatData, setChatData] = useState();
  const [activeChat, setActiveChat] = useState();
  const [newMenu, setNewMenu] = useState();
  const [allMentorships, setAllMentorships] = useState();
  const [data, setData] = useState();
  const onAttachFile = (e) => {
    setFile(e.target.files[0]);
  };
  const onBroadcastSelectionChange = (item, checked) => {
    const isThere = taggingList.find((ele) => {
      if (ele == item.id) return true;
    });
    if (checked) {
      if (!isThere) {
        setTaggingList([...taggingList, item.id]);
      }
    } else {
      if (isThere) {
        let newArray = taggingList.filter((ele) => ele != item.id);
        setTaggingList(newArray);
      }
    }
  };

  const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const getAllMentorships = () => {
    // axios({
    //   url: MY_MENTORSHIP_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId: value?.id,
    //   },
    // })
    api
      .POST(MY_MENTORSHIP_LIST, {
        mentorId: value?.id,
      })
      .then((res) => {
        setAllMentorships(res.data?.data);
      })
      .catch((err) => {});
  };

  const getAllCohortMentors = (cohortid) => {
    // axios({
    //   url: MATCH_MENTOR_LIST,
    //   method: "post",
    //   data: {
    //     cohortId: cohortid,
    //     // mentorId: value?.id,
    //     // listKey: "Mentor",
    //   },
    // })
    api
      .POST(MATCH_MENTOR_LIST, {
        cohortId: cohortid,
        // mentorId: value?.id,
        // listKey: "Mentor",
      })
      .then((res) => {
        setAllCohortMentors(res.data?.data);
      })

      .catch((err) => {});
  };

  // const getGroupmessages = (cohortid) => {
  //   axios({
  //     url: MATCH_MENTOR_LIST,
  //     method: "post",
  //     data: {
  //       cohortId: cohortid,
  //       // mentorId: value?.id,
  //       // listKey: "Mentor",
  //     },
  //   })
  //     .then((res) => {
  //       setGroupmessages(res.data?.data);
  //     })

  //     .catch((err) => {});
  // };

  const getAllCohortStartups = (cohortid) => {
    // axios({
    //   url: MATCH_STARTUP_LIST,
    //   method: "post",
    //   data: {
    //     cohortId: cohortid,
    //     // mentorId: value?.id,
    //     // listKey: "Startup",
    //   },
    // })
    api
      .POST(MATCH_STARTUP_LIST, {
        cohortId: cohortid,
        // mentorId: value?.id,
        // listKey: "Startup",
      })
      .then((res) => {
        setAllCohortStartups(res.data?.data);
      })
      .catch((err) => {});
  };

  const getAllConversations = () => {
    let value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

    // axios({
    //   url: ALL_CONVERSATION,
    //   method: "post",
    //   data: {
    //     senderId: value?.id,
    //   },
    // })
    api
      .POST(ALL_CONVERSATION, {
        senderId: value?.id,
      })
      .then((res1) => {
        let arr1 = res1.data?.data?.map((obj) => ({
          ...obj,
          lastUpdated: new Date(obj.lastUpdated),
        }));
        const sortedDesc = arr1.sort(
          (objA, objB) => Number(objB.lastUpdated) - Number(objA.lastUpdated)
        );

        setData(sortedDesc);

        // axios({
        //   url: MY_MENTORSHIP_LIST,
        //   method: "POST",
        //   data: {
        //     mentorId: value?.id,
        //   },
        // })
        api
          .POST(MY_MENTORSHIP_LIST, {
            mentorId: value?.id,
          })
          .then((res) => {
            let newConversations = res.data?.data?.filter((ele) => {
              let isTrue = true;
              res1.data?.data?.forEach((element) => {
                let otherPartyId =
                  element?.bpartyId === value?.id
                    ? element?.apartyId
                    : element?.bpartyId;
                if (ele.startupId == otherPartyId) isTrue = false;
              });
              return isTrue;
            });
            setNewMenu(newConversations);
          })
          .catch((err) => {});
      })
      .catch((err) => {});
  };

  const getChats = () => {
    if (activeChat) {
      const receiverId =
        activeChat.bpartyId === value?.id
          ? activeChat.apartyId
          : activeChat.bpartyId;
      // axios({
      //   url: MESSAGES,
      //   method: "post",
      //   data: {
      //     id: value?.id,
      //     senderId: value?.id,
      //     receiverId,
      //     pageFilter: {
      //       currentPage: 0,
      //       includeCount: true,
      //       pageSize: 1000,
      //       sortField: "createdDate",
      //       sortOrder: "DESC",
      //     },
      //   },
      // })
      api
        .POST(MESSAGES, {
          id: value?.id,
          senderId: value?.id,
          receiverId,
          pageFilter: {
            currentPage: 0,
            includeCount: true,
            pageSize: 1000,
            sortField: "createdDate",
            sortOrder: "DESC",
          },
        })
        .then((res) => {
          setChatData(res.data?.data);
        })
        .catch((err) => {});
    }
  };

  const onBroadcastMessage = () => {
    if (!inputValue && !file) {
      return;
    }
    let newTaggingList;
    if (taggingList?.length > 0) {
      newTaggingList = taggingList;
    } else {
      return;
    }
    // newTaggingList.map((tlist) => {

    // });

    const formData = new FormData();
    if (inputValue) {
      formData.append(
        "message",
        JSON.stringify({
          senderId: value?.id,
          senderName: value.name,
          receiverId: taggingList[0],
          message: {
            commentByUserId: value?.id,
            commentedByUserRole: value.role,
            text: inputValue,
          },
          taggingList,
          allExpertTag: false,
          allStudentTag: false,
        })
      );
    } else {
      formData.append(
        "message",
        JSON.stringify({
          senderId: value?.id,
          senderName: value.name,
          receiverId: taggingList[0],
          message: {
            commentByUserId: value?.id,
            commentedByUserRole: value.role,
            text: "",
          },
          taggingList,
          allExpertTag: false,
          allStudentTag: false,
        })
      );
    }
    if (file) {
      formData.append("commentFile", file, file?.name);
    }
    // axios({
    //   url: SEND_MESSAGE,
    //   method: "post",
    //   data: formData,
    // })
    api
      .POST(SEND_MESSAGE, formData)
      .then((res) => {})
      .catch((err) => {});

    setModalOpening(false);
    setTaggingList([]);
    setInputValue("");
    setFile(null);
  };

  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const [modalOpening, setModalOpening] = useState(false);

  const {
    getStartupApplication,
    startUpApplication,
    startUpApplicationPagineate,
    getTableDataPaginate,
    getTableData,
    getCountersStartUpList,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
  } = props;
  const ViewApplicationCohort = (item) => {
    let reRoute = window.open(`/view-CohortApplication/${item}`, "_blank");
    reRoute.id = item;

    reRoute.fromModule = "ViewApplicationCohort";
  };
  useEffect(() => {
    getAllConversations();
    getAllMentorships();
    // getAllCohortMentors();
    getAllCohortStartups();
  }, []);
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));

  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  if (loginrole === "Mentor" || loginrole === "Admin") {
    localStorage.setItem("cohortProgram", "cohortProgram");
  } else {
    localStorage.removeItem("cohortProgram");
    history.push("/startup-dashboard");
  }
  useEffect(() => {
    html.style.overflow = "auto";

    // localStorage.setItem("cohortProgram", "cohortProgram");
    setTimeout(() => {
      localStorage.removeItem("mentorRequests");
      localStorage.removeItem("activitySummary");
      localStorage.removeItem("activitySummary2");
      localStorage.removeItem("activitySummary3");
      localStorage.removeItem("activitySummary4");
      localStorage.removeItem("activitySummary5");
      localStorage.removeItem("activityCohortTotal");
      localStorage.removeItem("activityCohortDetails");
      localStorage.removeItem("mentorshipClosed");
      localStorage.removeItem("mentorshipScheduled");
      localStorage.removeItem("mentorshipTotal");
      localStorage.removeItem("mentorshipSession");
      localStorage.removeItem("startupMentorshipHours");
      localStorage.removeItem("startupRequestAccepted");
      localStorage.removeItem("startupRequestSent");
      // localStorage.removeItem("MyCohortStartupDashboard");
      // localStorage.removeItem("MyCohortMentorDashboard");

      // localStorage.removeItem("cohortMatchTable");
    }, 1000);
    console.log("LoginUser", LoginUser);
    if (props?.location?.state?.requestStatus === undefined) {
      if (LoginUser?.role == "Admin") {
        setActiveText3(true);
        setSelectedStatus("SPOTLIGHT");
        setTimeout(() => {
          getTableStatus("SPOTLIGHT", 0);
        }, 500);
      } else {
        setActiveText(true);
      }
    } else if (props?.location?.state?.requestStatus === "pending") {
      setActiveText2(true);
    } else if (props.location.state.requestStatus === "viewAll") {
      setActiveText(true);
    } else if (LoginUser?.role == "Admin") {
      setActiveText3(true);
      setSelectedStatus("SPOTLIGHT");
      setTimeout(() => {
        getTableStatus("SPOTLIGHT", 0);
      }, 500);
    } else setActiveText(true);
  }, []);
  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  const getTableDataStatus2 = (status) => {
    setcohortfilterGo(!cohortfilterGo);
  };
  useEffect(() => {
    getNamesListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Startup",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (getNamesListData.length >= nameListValue.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [getNamesListData]);

  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    if (LoginRole === "Mentor") {
      // axios({
      //   url: COHORT_NAME_LIST,
      //   method: "post",
      //   data: {
      //     mentorId:
      //       localStorage.getItem("SavedLoggedInData") &&
      //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //     status: "VERIFIED",
      //   },
      // })
      api
        .POST(COHORT_NAME_LIST, {
          mentorId:
            localStorage.getItem("SavedLoggedInData") &&
            JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
          status: "VERIFIED",
        })
        .then((res) => {
          // setCounterData(res.data?.data)
          res.data.data &&
            res.data.data.map((item, index) => {
              if (index === 0) {
                let arr2 = {
                  label: "Select Cohort Name",
                  value: "select",
                };
                setcohortnameList((oldArray) => [...oldArray, arr2]);
              }
              let arr = {
                label: item.name,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameList.length)
                setcohortnameList((oldArray) => [...oldArray, arr]);
            });
        })
        .catch((err) => {});

      // axios({
      //   url: COHORT_NAME_LIST,
      //   method: "post",
      //   data: {
      //     status: "VERIFIED",
      //     mentorId:
      //       localStorage.getItem("SavedLoggedInData") &&
      //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //   },
      // })
      api
        .POST(COHORT_NAME_LIST, {
          status: "VERIFIED",
          mentorId:
            localStorage.getItem("SavedLoggedInData") &&
            JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        })
        .then((res) => {
          res.data.data &&
            res.data.data.map((item, index) => {
              if (index === 0) {
                let arr2 = {
                  label: "Select Cohort Id",
                  value: "select",
                };
                setcohortnameId((oldArray) => [...oldArray, arr2]);
              }
              let arr = {
                label: `C${item.id.slice(-6)}`,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameId.length)
                setcohortnameId((oldArray) => [...oldArray, arr]);
            });
        })
        .catch((err) => {});

      // axios({
      //   url: COHORT_ADMIN_COUNTER,
      //   method: "post",
      //   data: {
      //     cohortAdminId:
      //       localStorage.getItem("SavedLoggedInData") &&
      //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //   },
      // })
      api
        .POST(COHORT_ADMIN_COUNTER, {
          cohortAdminId:
            localStorage.getItem("SavedLoggedInData") &&
            JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        })
        .then((res) => {
          // const cohortnameArray = [];

          setCohortAdminCounter(res.data.data);
        })
        .catch((err) => {});
    } else {
      // axios({
      //   url: COHORT_NAME_LIST,
      //   method: "post",
      //   data: {},
      // })
      api
        .POST(COHORT_NAME_LIST, { status: "VERIFIED" })
        .then((res) => {
          res.data.data &&
            res.data.data.map((item, index) => {
              if (index === 0) {
                let arr2 = {
                  label: "Select Cohort Name",
                  value: "select",
                };
                setcohortnameList((oldArray) => [...oldArray, arr2]);
              }

              if (item.name !== null && item.name !== "") {
                let arr = {
                  label: item.name,
                  value: item.id,
                };
                if (res.data.data.length >= cohortnameList.length)
                  setcohortnameList((oldArray) => [...oldArray, arr]);
              }
            });
        })
        .catch((err) => {});

      // axios({
      //   url: COHORT_ADMIN_COUNTER,
      //   method: "post",
      //   data: {},
      // })
      api
        .POST(COHORT_ADMIN_COUNTER, {})
        .then((res) => {
          setCohortAdminCounter(res.data.data);
        })
        .catch((err) => {});

      // axios({
      //   url: COHORT_NAME_LIST,
      //   method: "post",
      //   data: {
      //     status: "VERIFIED",
      //   },
      // })
      api
        .POST(COHORT_NAME_LIST, {
          status: "VERIFIED",
        })
        .then((res) => {
          // const cohortnameArray = [];
          const cohortidArray = [];

          res.data.data &&
            res.data.data.map((item, index) => {
              if (index === 0) {
                let arr2 = {
                  label: "Select Cohort Id",
                  value: "select",
                };
                setcohortnameId((oldArray) => [...oldArray, arr2]);
              }
              let arr = {
                label: `C${item.id.slice(-6)}`,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameId.length)
                setcohortnameId((oldArray) => [...oldArray, arr]);
            });
        })
        .catch((err) => {});
    }
    // getAllData()
  }, []);
  const approvalOptions = [
    {
      value: "Approve",
      label: "Approve",
    },
    { value: "Reject", label: "Reject" },
    { value: "Request Info", label: "Request Info" },
  ];
  const fetchCounterData = () => {
    api
      .POST(COHORT_ADMIN_COUNTER, {})
      .then((res) => {
        setCohortAdminCounter(res.data.data);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    let params = {
      cohortId: filterCohortId == "select" ? "" : filterCohortId,
      cohortAdminId:
        LoginRole === "Mentor"
          ? JSON.parse(localStorage.getItem("SavedLoggedInData")).id
          : "",
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      searchField:
        LoginRole === "Mentor"
          ? JSON.parse(localStorage.getItem("SavedLoggedInData")).id
          : "",
      searchKey: null,
      status: selectedStatus,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  }, [cohortfilterGo]);
  const getTableStatus = (status, pageNumber) => {
    let params = {
      cohortId: filterCohortId == "select" ? "" : filterCohortId,
      cohortAdminId:
        LoginRole === "Mentor"
          ? JSON.parse(localStorage.getItem("SavedLoggedInData")).id
          : "",
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      searchField:
        LoginRole === "Mentor"
          ? JSON.parse(localStorage.getItem("SavedLoggedInData")).id
          : "",
      searchKey: null,
      status: status,
      pageFilter: {
        currentPage: pageNumber,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  };
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "15.5vw",
      whiteSpace: "nowrap",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
  };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      requestedBy: "",
      status: selectedStatus,
      pageFilter: {
        currentPage: pageNumber - 1,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField:
        LoginRole === "Mentor"
          ? JSON.parse(localStorage.getItem("SavedLoggedInData")).id
          : "",
      searchKey: null,
      country: "",
      status: selectedStatus,
      // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      state: formData.state == "select" ? null : formData?.state?.value, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getMentorCohortApplicationList(params);
    // getStartupApplication(params);
  };

  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);
  const getExcelDownload = () => {
    api
      .GET(`${DOWNLOAD_EXCEL_TOTAL_COHORT_MENTORSHIP_HOURS}`, {
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `TotalCohortMentorshipHours.xls`);
        document.body.appendChild(link);
        link.click();
      });
  };
  const spotLightFn = (data, status) => {
    let params = {
      id: data?.cohortId,
      // applicationId:data?.cohort?.applicationId,
      spotlight: status,
      priority: 1,
    };
    cohortProgramSpotLight(params, data?.program_name);
    setTimeout(function () {
      getTableStatus(selectedStatus, activePage - 1);
      fetchCounterData();
    }, 1500);
  };

  return (
    <>
      <Modalmessage
        newCohortId={newCohortId}
        modalOpen={modalOpening}
        cohortNewData={cohortNewData}
        setModalOpen={setModalOpening}
        allCohortMentors={allCohortMentors}
        groupMessages={groupMessages}
        allCohortStartups={allCohortStartups}
        allMentorships={allMentorships}
        onSubmitMessage={onBroadcastMessage}
        inputValue={inputValue}
        setTaggingList={setTaggingList}
        setInputValue={setInputValue}
        file={file}
        onAttachFile={onAttachFile}
        onBroadcastSelectionChange={onBroadcastSelectionChange}
        taggingList={taggingList}
      />
      <div className="chrtprogramsmaindivadmin">
        <div
          className="dashboard-main2 cohortprogramdiv"
          style={{ background: "none" }}
        >
          <div
            className="dashboard-bottom-btn4 topbackbtnmentorlist"
            style={{ background: "transparent", border: "none" }}
          >
            <div className="newuserTooltip">
              <MaterialButton
                className="topbackbtnactual top-btn"
                variant="contained"
                color="primary"
                onClick={() => {
                  if (LoginRole === "Mentor") {
                    if (
                      history?.location?.state?.fromModule !== undefined &&
                      history?.location?.state?.fromModule !== null &&
                      history?.location?.state?.fromModule ===
                        "cohortStartupRequest"
                    ) {
                      props.setSelectedMenu("cohortStartup");
                      history.push("/dashboard");
                    } else if (
                      history?.location?.state?.fromModule !== undefined &&
                      history?.location?.state?.fromModule !== null &&
                      history?.location?.state?.fromModule ===
                        "cohortMentorApplication"
                    ) {
                      props.setSelectedMenu("cohortApplicationMentor");
                      history.push("/dashboard");
                    } else if (
                      history?.location?.state?.fromModule !== undefined &&
                      history?.location?.state?.fromModule !== null &&
                      history?.location?.state?.fromModule ===
                        "cohortMentorRequest"
                    ) {
                      props.setSelectedMenu("cohortMentors");
                      history.push("/dashboard");
                    } else {
                      props.setSelectedMenu("adminMenu");
                      history.push("/dashboard");
                    }
                  } else {
                    if (
                      history?.location?.state?.fromModule ===
                        "activitySummary" ||
                      history?.location?.state?.fromModule ===
                        "activityCohortMentorships"
                    ) {
                      localStorage.setItem(
                        "activitySummary",
                        "activitySummary"
                      );

                      window.location.reload();
                      // cohortApplication
                    } else if (
                      history.location.state.fromModule ===
                      "cohortAdminApplication"
                    ) {
                      localStorage.setItem(
                        "cohortApplication",
                        "cohortApplication"
                      );

                      window.location.reload();
                      // cohortApplication
                    } else {
                      localStorage.setItem(
                        "mentorDashboardHome",
                        "mentorDashboardHome"
                      );
                      localStorage.removeItem("cohortProgram");
                      window.location.reload();
                    }
                  }
                }}
                style={{ background: "#3ac2d7" }}
              >
                {" "}
                Back
              </MaterialButton>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  top: "69px",
                  width: "217px",
                  left: "71px",
                }}
              >
                {history?.location?.state?.fromModule ===
                "cohortMentorApplication"
                  ? "Click to Go Cohort Applications "
                  : history?.location?.state?.fromModule === "activitySummary"
                  ? "Click to Go Activity Summary"
                  : history?.location?.state?.fromModule ===
                    "activityCohortMentorships"
                  ? "Click to Go Activity Summary"
                  : history?.location?.state?.fromModule ===
                    "cohortAdminApplication"
                  ? "Click to Go Cohort Applications"
                  : "Click to Go My Dashboard "}
              </span>
            </div>

            <Modal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              modalData={modalData}
            />

            {modalVisibility && (
              <CohortSummaryModal
                setModalVisibility={setModalVisibility}
                modalVisibility={modalVisibility}
                fromModule={fromModule}
                cohortId={cohortModalData}
                fromPage={"mentorships"}
              />
            )}

            {modalVisibility2 && (
              <MentorshipSummaryModal
                setModalVisibility={setModalVisibility2}
                modalVisibility={modalVisibility2}
                cohortId={cohortModalMentorData2}
              />
            )}
          </div>
          <div className="iconWith-heading iconheadingdata">
            <div style={{ width: "100%" }}>
              {/* <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3> */}
              {history?.location?.state?.fromModule &&
              history?.location?.state?.fromModule ===
                "activityCohortMentorships" ? (
                <h3 className="dashboard-sub-heading fadeInDown wow">
                  ACTIVITY SUMMARY: MENTORSHIP HOURS
                </h3>
              ) : (
                <h3 className="dashboard-sub-heading fadeInDown wow">
                  {LoginRole === "Admin"
                    ? "ALL COHORTS"
                    : "COHORT PROGRAMS"}
                </h3>
              )}
            </div>
            <a onClick={() => getExcelDownload()}>
              <div className="newuserTooltip">
                <img
                  className="excelButton excelbuttonadmindash"
                  src={excelButton}
                  style={{ top: "2.4rem", width: "47%", left: "0rem" }}
                ></img>
                <span
                  className="tooltiptext   tooltip-bottom admincohort01"
                  style={{ left: "0.5rem", top: "5.75rem", width: "12vw" }}
                >
                  Download Excel Report
                </span>
              </div>
            </a>
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";
              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>

        <div className="col-md-11 display-center mobilementorsummary">
          {history?.location?.state?.fromModule &&
          history?.location?.state?.fromModule ===
            "activityCohortMentorships" ? (
            <div className="admin-bottom-card row ">
              <div
                className="mentorImageParent d-flex justify-content-end"
                style={{
                  background: "none",
                  border: "0px",
                  borderRadius: "0px",
                }}
              >
                <img src={mentorIcon} className="sidebar-dashboard-icon2" />
              </div>
              <div className="dashboard-bottom-btn3">
                <p className="text-white">COHORTS</p>
              </div>
              <div class="w-20 newuserTooltip circleBorder maxtotalCount">
                {history?.location?.state?.pageCounter}
              </div>
              <div class="w-40 newuserTooltip activitySummaryText last15days">
                Total Mentorship Hours from the cohort-based program
              </div>
              {/* <div class="w-20 newuserTooltip">
           X
          </div> */}
            </div>
          ) : (
            <div className="admin-bottom-cardNew002 row mobileviewmentorbelow">
              <div
                className="mentorImageParent newmentorparent"
                style={{
                  background: "none",
                  border: "0px",
                  borderRadius: "0px",
                  position: "relative",
                  // marginLeft: "4rem",
                }}
              >
                <img
                  src={mentorshipIcon}
                  className="sidebar-dashboard-icon3 mentor-05"
                />
              </div>
              <div
                className="col-xs-6 col-sm-6 col-md-2 col-lg-2 mentorAppButton newappbtnnew"
                style={{
                  position: "relative",
                  // marginLeft: "1rem"
                }}
              >
                <div className="dashboard-bottom-btn2005">
                  <p className="text-white2"> COHORT STATUS</p>
                </div>
              </div>
              <div
                className="col-xs-6 col-sm-6 col-md-2 col-lg-2  newuserTooltip totalcohortnew"
                style={{
                  position: "relative",
                  // marginLeft: "1rem"
                }}
              >
                <p
                  onClick={() => {
                    setActiveText(true);
                    setActiveText2(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActivePage(1);
                    getTableStatus("VERIFIED", 0);
                    setSelectedStatus("VERIFIED", 0);
                    //   getStartupApplicationTable("");
                  }}
                  style={{
                    color: "#838186",
                    cursor: "pointer",
                  }}
                  className="admindasheaderoptions"
                >
                  TOTAL COHORTS : {cohortAdminCounter.totalCohorts}
                </p>
                <span className="tooltiptext   tooltip-bottom totalmentors-02">
                  Click to View Total Cohorts
                </span>
                {activeText ? (
                  <img className="requestStatusBar" src={LineWithDot} />
                ) : (
                  ""
                )}
              </div>
              <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip">
                <p
                  onClick={() => {
                    setActiveText2(true);
                    setActiveText(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActivePage(1);
                    setSelectedStatus("ACTIVE", 0);
                    getTableStatus("ACTIVE", 0);
                  }}
                  style={{ color: activeText2 ? "#277acc" : "#838186" }}
                  className="admindasheaderoptions applicationHeading2300 activecohortnew"
                >
                  {" "}
                  ACTIVE : {cohortAdminCounter.active}
                </p>
                <span
                  className="tooltiptext   tooltip-bottom"
                  style={{ left: "70px", width: "220px" }}
                >
                  Click to View Active Cohorts
                </span>
                {activeText2 ? (
                  <img
                    className="requestStatusBar positionBar000523 activecohortnewbar"
                    src={LineWithDot}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip">
                <p
                  onClick={() => {
                    setActiveText3(true);
                    setActiveText(false);
                    setActiveText2(false);
                    setActiveText4(false);
                    setActivePage(1);
                    setSelectedStatus("SPOTLIGHT", 0);
                    getTableStatus("SPOTLIGHT", 0);
                  }}
                  style={{ color: activeText3 ? "#277acc" : "#838186" }}
                  className="admindasheaderoptions applicationHeading2300 activecohortnew"
                >
                  {" "}
                  SPOTLIGHT : {cohortAdminCounter.spotlight}
                </p>
                <span
                  className="tooltiptext   tooltip-bottom"
                  style={{ left: "70px", width: "220px" }}
                >
                  Click to View Spotlight Cohorts
                </span>
                {activeText3 ? (
                  <img
                    className="requestStatusBar positionBar000523 activecohortnewbar"
                    src={LineWithDot}
                  />
                ) : (
                  ""
                )}
              </div>
              <div
                className="col-xs-6 col-sm-6 col-md-1 col-lg-1 newuserTooltip"
                style={{ position: "relative", right: "1%" }}
              >
                <p
                  onClick={() => {
                    setActiveText2(false);
                    setActiveText(false);
                    setActiveText3(false);
                    setActivePage(1);
                    setActiveText4(true);
                    setSelectedStatus("CLOSED", 0);
                    getTableStatus("CLOSED", 0);
                    //   getStartupApplicationTable("PENDING");
                    // getMentorApplications("PENDING");
                  }}
                  // style={{ color: activeText3 ? "#277acc" : "#838186" }}
                  style={{
                    color: activeText4 ? "#277acc" : "#838186",
                    // color: "#838186",
                    cursor: "pointer",
                  }}
                  className="admindasheaderoptions applicationHeading23001 closecohortnew"
                >
                  {" "}
                  CLOSED : {cohortAdminCounter && cohortAdminCounter?.closed}
                  {/* {getCounterStartUp && getCounterStartUp.pending !== null
                  ? getCounterStartUp.pending
                  : 0} */}
                </p>
                <span
                  className="tooltiptext   tooltip-bottom"
                  style={{ left: "70px", width: "220px" }}
                >
                  Click to View Closed Cohorts
                </span>
                {activeText4 ? (
                  <img
                    className="requestStatusBar positionBar000524 closecohortnewbar"
                    src={LineWithDot}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
          <div className="filter-row filter-row-common filterDivMentorapp">
            <div>
              <form className="formContainer newfilterdivnow">
                <div className="row desktopFilterRow">
                  <div
                    className="col-11 d-flex justify-content-between"
                    style={{ position: "relative", right: "0.3rem" }}
                  >
                    <div className="dropDownWidthFix36 newuserTooltip">
                      <Select
                        required={true}
                        id="cohortorgname"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortorgname"
                        className="col-12 gendermentorinput "
                        styles={customStyles}
                        value={formData.cohortorgname}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortorgname: e.value == "select" ? null : e,
                            };
                          });
                          setFilterCohortId(e.value);
                        }}
                        options={cohortnameList}
                        placeholder="Cohort Name"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "150px" }}
                      >
                        Search Cohort Name
                      </span>
                    </div>
                    <div className="dropDownWidthFix36 newuserTooltip">
                      <Select
                        required={true}
                        id="cohortId"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortId"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortId}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortId: e.value == "select" ? null : e,
                            };
                          });
                          setFilterCohortId(e.value);
                        }}
                        options={cohortnameId}
                        placeholder="Cohort ID"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "160px" }}
                      >
                        Search Cohort ID
                      </span>
                    </div>
                    <div className="dropDownWidthFix36 newuserTooltip">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>
                    <div className="dropDownWidthFix36 newuserTooltip">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="dropDownWidthFix36 newuserTooltip">
                      <Select
                        required={true}
                        id="stage"
                        // label="Gender*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Stage
                      </span>
                    </div>
                  </div>

                  <div
                    className="apply-section d-flex justify-content-end col-1 newuserTooltip"
                    style={{ position: "relative", left: "1.2rem" }}
                  >
                    <Button
                      onClick={getTableDataStatus2}
                      text="GO"
                      className="filter-button top-btn newcoloredbtn startupColorBtn"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "46px",
                        width: "126px",
                        height: "48px",
                        top: "42px",
                      }}
                    >
                      Click to Apply Filters
                    </span>
                  </div>
                </div>

                <div className="row mobileFilterRow mobiefiltercohortprogramnew">
                  <div className="col-md-1 filter-text">Filter by</div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortorgname"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortorgname"
                      className="col-12 gendermentorinput selectofcohortprog cohrotnamemobilechrtprg"
                      styles={customStyles}
                      value={formData.cohortorgname}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortorgname: e.value == "select" ? null : e,
                          };
                        });
                        setFilterCohortId(e.value);
                      }}
                      options={cohortnameList}
                      placeholder="Cohort Name"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortId"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortId"
                      className="col-12 gendermentorinput selectofcohortprog"
                      styles={customStyles}
                      value={formData.cohortId}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortId: e.value == "select" ? null : e,
                          };
                        });
                        setFilterCohortId(e.value);
                      }}
                      options={cohortnameId}
                      placeholder="Cohort ID"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput selectofcohortprog industrycohrotprogrammobile"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput selectofcohortprog"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput selectofcohortprog"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>

                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      onClick={getTableDataStatus2}
                      //   onClick={() => getStartupApplicationTable(selectedStatus)}
                      text="GO"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="totalTableCount">
            Total Cohort Programs : {getTableDataPaginate?.totalElements} &lt;{" "}
            {getTableDataPaginate?.currentPage} of{" "}
            {getTableDataPaginate?.numPages} &gt;{" "}
          </div>
          {getTableData && getTableData?.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered cohrotprogtableadmin">
                  <thead>
                    <tr>
                      <th
                        style={{ verticalAlign: "middle" }}
                        className="fixColumbnWidth4"
                      >
                        {" "}
                        <div>NO.</div>
                      </th>
                      <th
                        style={
                          LoginRole == "Admin"
                            ? { verticalAlign: "middle", minWidth: "23.5rem" }
                            : { verticalAlign: "middle", minWidth: "24rem" }
                        }
                        className="fixColumbnWidth"
                        colspan="2"
                      >
                        <div>COHORT DETAILS</div>
                      </th>
                      <th
                        style={{
                          maxWidth: "7rem",
                          fontSize: "15.3px",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <div>COHORT ID</div>
                      </th>
                      <th
                        className="fixColumbnWidth4 headingWidthFixProgram"
                        style={{
                          whitespace: "nowrap",
                          fontSize: "15.3px",
                          verticalAlign: "middle",
                          minWidth: "3.5rem",
                        }}
                      >
                        <div>MENTORS ENGAGED</div>
                      </th>
                      <th
                        className="fixColumbnWidth7 headingWidthFixProgram"
                        style={{ verticalAlign: "middle", minWidth: "2rem",maxWidth:"6rem" }}
                      >
                        <div>STARTUPS ENGAGED</div>
                      </th>
                      {/* <th className="fixColumbnWidth7">REQUEST DATE</th> */}
                      <th
                        className="fixColumbnWidth7 headingWidthFixProgram"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div>MENTORSHIPS</div>
                      </th>
                      <th
                        className="fixColumbnWidth7"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div>SESSIONS</div>
                      </th>
                      <th
                        className="fixColumbnWidth7"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div>HOURS</div>
                      </th>
                      {LoginRole == "Admin" && (
                        <th
                          className="fixColumbnWidth7"
                          style={{ verticalAlign: "middle" }}
                        >
                          <div>SPOTLIGHT</div>
                        </th>
                      )}
                    </tr>
                  </thead>
                  {getTableData.map((item, index) => (
                    <tbody>
                      <tr
                        className={
                          item.id === selectedRow ? "purpleBackground" : ""
                        }
                        key={index}
                      >
                        <td style={{ verticalAlign: "middle" }}>
                          {getTableDataPaginate.currentPage === 1 ? (
                            // <td>
                            <div>{index + 1}</div>
                          ) : (
                            // </td>
                            // <td>
                            <div>
                              {index +
                                1 +
                                10 * (getTableDataPaginate.currentPage - 1)}
                            </div>
                            // </td>
                          )}
                        </td>
                        <td
                          style={{
                            verticalAlign: "middle",
                          }}
                          className={
                            LoginRole === "Admin"
                              ? "chrtdetailschrtprogamdin"
                              : "chrtdetailschrtprogamdin29"
                          }
                        >
                          <div
                            className="newuserTooltip"
                            style={{
                              width: "100px",
                              height: "100px",
                              maxWidth: "none",
                              objectFit: "contain",
                            }}
                          >
                            <img
                              onClick={
                                () => {
                                  let reRoute = window.open(
                                    sample + `/cohort-programs/cohortView/${item?.id}`,
                                    "_blank"
                                  );
                                }
                                // history.push(`/cohort-programs/all/${item?.cohortID}`)
                              }
                              src={
                                item.uploadBanner === null
                                  ? hashImage
                                  : item.uploadBanner
                              }
                              className="sidebar-dashboard-icon2"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                cursor: "pointer",
                                position: "relative",
                                // top: "1rem",
                              }}
                            />
                            <span
                              className="tooltiptext tooltip-bottom "
                              style={{
                                left: "32px",
                                top: "110px",
                                width: "150px",
                              }}
                            >
                              {item.applicationStatus === "VERIFIED"
                                ? "View Cohort Details"
                                : "Cohort Preview"}
                            </span>
                            <div
                              style={{
                                cursor: "pointer",
                                alignItems: "center",
                                display: "flex",
                                // minWidth: "200px",
                              }}
                              className="chrtdetailsseconddivmobile"
                            >
                              {item?.program_name?.length > 20 ? (
                                <div className="tooltipicon">
                                  {item?.program_name.substring(0, 10)}
                                  <svg
                                    style={{
                                      position: "relative",
                                      top: "0.1rem",
                                      cursor: "pointer",
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    class="bi bi-three-dots"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                  </svg>
                                  <span className="tooltiptext7">
                                    <h5 style={{ color: "#fff" }}>
                                      Program Name
                                    </h5>
                                    {item?.program_name}
                                  </span>
                                </div>
                              ) : (
                                item?.program_name
                              )}
                              {/* {item.program_name} */}
                              <br></br>
                              {/* {item.organization_name} */}
                              {item?.organization_name?.length > 15 ? (
                                <div className="tooltipicon">
                                  {item?.organization_name.substring(0, 10)}
                                  <svg
                                    style={{
                                      position: "relative",
                                      top: "0.1rem",
                                      cursor: "pointer",
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    class="bi bi-three-dots"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                  </svg>
                                  <span className="tooltiptext7">
                                    <h5 style={{ color: "#fff" }}>
                                      Organization Name
                                    </h5>
                                    {item?.organization_name}
                                  </span>
                                </div>
                              ) : (
                                item?.organization_name
                              )}
                              {/* <p style={{ fontWeight: "bold" }}>Start Date: </p>
                              <p>
                                {moment(item?.cohort_date).format("DD/MM/YYYY")}
                              </p> */}
                              {item?.cohort_date ? (
                                <>
                                  <p style={{ fontWeight: "bold" }}>
                                    Start Date:{" "}
                                  </p>{" "}
                                  <p>
                                    {" "}
                                    {moment(item?.cohort_date).format(
                                      "DD/MM/YYYY"
                                    )}{" "}
                                  </p>{" "}
                                  <br />{" "}
                                </>
                              ) : (
                                ""
                              )}
                              <p style={{ fontWeight: "bold" }}>
                                Duration:{" "}
                                <span style={{ fontWeight: "normal" }}>
                                  {item.program_duration}
                                </span>
                              </p>
                              <br></br>
                            </div>
                            <div
                              className="newuserTooltip vwchrtdtailschrtprogmbl"
                              style={{
                                cursor: "pointer",
                                alignItems: "end",
                                justifyContent: "right",
                                flexDirection: "column",
                                display: "flex",
                              }}
                            >
                              {LoginRole === "Admin" ? (
                                ""
                              ) : (
                                <img
                                  width={40}
                                  src={buttonSendMessage}
                                  onClick={() => {
                                    setModalOpening(true);
                                  }}
                                />
                              )}
                              <img
                                src={profile}
                                height={40}
                                width={40}
                                onClick={() => {
                                  let reRoute = window.open(
                                    sample + `/cohort-programs/cohortView/${item?.id}`,
                                    "_blank"
                                  );
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "14px",
                                  top: "145px",
                                  width: "150px",
                                }}
                              >
                                {item.applicationStatus === "VERIFIED"
                                  ? "View Cohort Details"
                                  : "Cohort Preview"}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td className="mntridchrtprogamdin">
                          <div
                            style={{
                              flexDirection: "row",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                cursor: "pointer",
                                // alignItems: "center",
                                display: "flex",
                                flexDirection: "column",
                                maxWidth: "12rem",
                                width: "100%",
                                height: "fit-content",
                                overflowWrap: "break-word",
                                // minWidth: "200px",
                              }}
                            >
                              {item.program_name}
                              <br></br>
                              {item.organization_name}
                              <br></br>
                              {item?.cohort_date ? (
                                <>
                                  Start Date:{" "}
                                  {moment(item?.cohort_date).format(
                                    "DD/MM/YYYY"
                                  )}{" "}
                                  <br />{" "}
                                </>
                              ) : (
                                ""
                              )}
                              Duration: {item.program_duration + " " + "Months"}
                              <span style={{ fontSize: "16px" }}>
                                Cohort Status:{" "}
                                <b>
                                  {item?.cohort?.cohortStatus == "ABOUTTOCLOSE"
                                    ? "CLOSES SOON"
                                    : item?.cohort?.cohortStatus}
                                </b>
                              </span>
                              {item?.cohort?.daysPending &&
                              item?.cohort?.daysPending != 0 ? (
                                <span style={{ color: "#563A96" }}>
                                  Days Left to close:{" "}
                                  {item?.cohort?.daysPending}
                                  <br></br>
                                </span>
                              ) : (
                                ""
                              )}
                            </div>

                            <div
                              style={{
                                cursor: "pointer",
                                alignItems: "end",
                                justifyContent: "end",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {LoginRole === "Admin" ? (
                                ""
                              ) : (
                                <div className="newuserTooltip">
                                  <img
                                    src={buttonSendMessage}
                                    width={40}
                                    onClick={() => {
                                      getAllCohortMentors(item?.cohortId);
                                      // getGroupmessages(item?.cohortId);
                                      getAllCohortStartups(item?.cohortId);
                                      setModalOpening(true);
                                      setnewCohortId(item?.cohortId);
                                      setCohortNewData(item);
                                    }}
                                  />

                                  <span
                                    className="tooltiptext  close-summary "
                                    style={{
                                      left: "-60px",
                                      top: "-35px",
                                      width: "165px",
                                    }}
                                  >
                                    Send Group Message
                                  </span>
                                </div>
                              )}
                              <div className="newuserTooltip">
                                <img
                                  src={profile}
                                  height={44}
                                  width={44}
                                  onClick={() => {
                                    let reRoute = window.open(
                                      sample +
                                        `/cohort-programs/cohortView/${item?.id}`,
                                      "_blank"
                                    );
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "14px",
                                    top: "50px",
                                    width: "150px",
                                  }}
                                >
                                  {item.applicationStatus === "VERIFIED"
                                    ? "View Cohort Details"
                                    : "Cohort Preview"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="chrtidchrtprogamdin"
                        >
                          <div className="newuserTooltip">
                            <a
                              onClick={() => {
                                ViewApplicationCohort(item.id);
                              }}
                              // href="#"
                              className="color-green"
                            >
                              {" "}
                              {item.cohortId !== null &&
                                item.cohortId !== "" &&
                                "C" +
                                  item.cohortId.substring(
                                    item.cohortId.length - 6
                                  )}
                            </a>
                            <span
                              className="tooltiptext mentoricon tooltip-bottom"
                              style={{ width: "12.5vw" }}
                            >
                              View Cohort Application
                            </span>
                          </div>
                          <div className="mt-2">
                            {moment(item?.date_applied).format("DD/MM/YYYY")}
                          </div>
                        </td>
                        <td
                          style={{ position: "relative" }}
                          className="menengchrtprogtd"
                        >
                          <div className="IconWithData menengchrtprogadmin">
                            <div className="middleData">
                              {item?.mentorsEngaged}
                            </div>
                            {item?.mentorsEngaged &&
                            item?.mentorsEngaged !== 0 ? (
                              <div
                                className="d-flex justify-content-end newuserTooltip cohort-programIcons"
                                onClick={() => {
                                  setCohortModalMentorData((data) => []);
                                  setModalVisibility(true);
                                  setFromModule("Mentor");
                                  setCohortModalData(item.cohortId);

                                  // getCohortMentorFunction(item.cohortId);
                                }}
                              >
                                <img
                                  src={mentorshipIcon4}
                                  height={44}
                                  width={44}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    position: "absolute",
                                    left: "2px",
                                    top: "216px",
                                    width: "170px",
                                  }}
                                >
                                  View Mentors Engaged
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                        <td
                          style={{ position: "relative" }}
                          className="menengchrtprogtd"
                        >
                          <div className="IconWithData menengchrtprogadmin">
                            <div className="middleData ">
                              {item?.startupsEngaged}
                            </div>
                            {item?.startupsEngaged &&
                            item?.startupsEngaged !== 0 ? (
                              <div
                                className="d-flex justify-content-end newuserTooltip cohort-programIcons2"
                                onClick={() => {
                                  setCohortModalMentorData((data) => []);
                                  setModalVisibility(true);
                                  setFromModule("Startup");
                                  setCohortModalData(item.cohortId);
                                }}
                              >
                                <img
                                  src={mentorshipIcon3}
                                  height={35}
                                  width={35}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    position: "absolute",
                                    left: "2px",
                                    top: "216px",
                                    width: "170px",
                                  }}
                                >
                                  View Startups Engaged
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                        <td
                          style={{ position: "relative" }}
                          className="menengchrtprogtd"
                        >
                          <div className="IconWithData menengchrtprogadmin">
                            <div className="middleData">
                              {item?.mentorships}
                            </div>
                            {item?.startupsEngaged &&
                            item?.mentorships !== 0 ? (
                              <div
                                className="d-flex justify-content-end newuserTooltip cohort-programIcons"
                                onClick={() => {
                                  setCohortModalMentorData2(item.cohortId);
                                  setModalVisibility2(true);
                                }}
                              >
                                <img
                                  src={mentorshipIcon2}
                                  height={40}
                                  width={40}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "14px",
                                    top: "145px",
                                    width: "150px",
                                  }}
                                >
                                  View Mentorships
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                        <td
                          style={{
                            whiteSpace: "nowrap",
                            verticalAlign: "middle",
                          }}
                        >
                          <div className="sessnschrtprogadmndash">
                            Total : {item?.totalSessions}
                            <br />
                            Completed : {item?.sessionsCompleted}
                            <br />
                            Upcoming : {item?.sessionsScheduled}
                          </div>
                        </td>
                        <td
                          style={{
                            whiteSpace: "nowrap",
                            verticalAlign: "middle",
                          }}
                        >
                          <div className="sessnschrtprogadmndash">
                            Total : {item?.hoursTotal}
                            <br />
                            Completed : {item?.hoursCompleted}
                            <br />
                            Upcoming : {item?.hoursScheduled}
                          </div>
                        </td>
                        {LoginRole == "Admin" && (
                          <td
                            className="fixColumbnWidth7"
                            style={{ verticalAlign: "middle" }}
                          >
                            {item?.cohort?.cohortStatus !== "CLOSED" ? (
                              <div>
                                <input
                                  type="checkbox"
                                  className="cohortCheckBox"
                                  name="cohortCheckBox"
                                  checked={item?.spotlight}
                                  onClick={(e) =>
                                    spotLightFn(item, !item?.spotlight)
                                  }
                                />
                              </div>
                            ) : (
                              <div>
                                <div>
                                  <input
                                    type="checkbox"
                                    className="cohortCheckBox"
                                    name="cohortCheckBox"
                                    checked={item?.spotlight}
                                    disabled
                                  />
                                </div>
                                {item?.spotlight && (
                                  <div>
                                    Spotlight Period :{" "}
                                    {moment(item?.cohort_date).format(
                                      "DD/MM/YYYY"
                                    )}{" "}
                                    to{" "}
                                    {moment(item?.cohortEnd).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </td>
                        )}
                      </tr>
                    </tbody>
                  ))}
                </table>
                <div className="pagination-box">
                  {getTableDataPaginate !== undefined && (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={getTableDataPaginate.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData: state.MentorReducer.getCohortMentorList.data,
    getTableDataPaginate: state.MentorReducer.getCohortMentorList.paginate,
    cohortMentorData: state.MentorReducer.getCohortMentorModuleList.data,
    cohortSpotLightData: state.MentorReducer.cohortProgramSpotLight.data,
    cohortStartupData:
      state.MentorReducer.getStartupCohortMentorModuleList.data,
    cohortMatchMakingList: state.MentorReducer.getMatchMakingResult.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  //   getStartupApplication,
  //   getCountersStartUpList,
  postMentorModuleCohort,
  postMentorModuleStartupCohort,
  getPredefineOptionsList,
  getNamesList,
  getMentorCohortApplicationList,
  getmatchTableList,
  getStepperTooltipData,
  cohortProgramSpotLight,
})(withRouter(CohortProgram));
